function Project(data) {
	this.data = data;// TODO: validating}
}

Project.prototype.getId = function() {
	return this.data.id;
};

Project.prototype.getName = function() {
	return this.data.name;
};

Project.prototype.getDescription = function() {
	return this.data.description;
};

Project.prototype.getStatus = function() {
	return this.data.status;
};

Project.prototype.getStatusLabel = function() {
	return this.data.statusLabel;
};

Project.prototype.getRentBuyStatus = function() {
	return this.data.rentBuyStatus;
};

Project.prototype.getRentBuyStatusLabel = function() {
	return this.data.rentBuyStatusLabel;
};

Project.prototype.getUrl = function() {
	return this.data.url;
};

Project.prototype.getFeaturedImageSrc = function() {
	return this.data.featuredImage ? this.data.featuredImage.src : '';
};

Project.prototype.getFeaturedImageAlt = function() {
	return this.data.featuredImage ? this.data.featuredImage.alt : '';
};

Project.prototype.getAvailableObjectsCount = function() {
	return typeof this.data.availableRealEstateObjectsCount === 'number' ? this.data.availableRealEstateObjectsCount : null;
};

// TODO: remove "fromHouseTypes" when Nieuwbouw Nederland supports all property types on objects
Project.prototype.getPropertyTypes = function(fromHouseTypes) {
	return fromHouseTypes ?
		this.data.houseTypes.map(houseType => houseType.propertyType).filter((propertyType, index, propertyTypes) => propertyTypes.indexOf(propertyType) === index).map(propertyType => ({ label: propertyType, value: propertyType })) :
		this.data.realEstateObjects.map(realEstateObject => realEstateObject.propertyType).filter((propertyType, index, propertyTypes) => propertyTypes.findIndex(propertyTypeToFind => propertyTypeToFind.value === propertyType.value) === index);
};

Project.prototype.getLowestPriceObjectPriceFormattedWithComposition = function() {
	const lowestPriceObject = this.getLowestPriceObject();

	return lowestPriceObject ? lowestPriceObject.priceFormattedWithComposition : '';
};

Project.prototype.getLowestPriceObject = function() {
	const realEstateObjectsSorted = this.data.realEstateObjects.filter(object => typeof object.price === 'number').sort((a, b) => {
		if (a.price < b.price) {
			return -1;
		}
		if (a.price > b.price) {
			return 1;
		}
		return 0;
	});

	return realEstateObjectsSorted.length > 0 && realEstateObjectsSorted[0] ? realEstateObjectsSorted[0] : null;
};

Project.prototype.getHighestPriceObject = function() {
	const realEstateObjectsSorted = this.data.realEstateObjects.filter(object => typeof object.price === 'number').sort((a, b) => {
		if (a.price > b.price) {
			return -1;
		}
		if (a.price < b.price) {
			return 1;
		}
		return 0;
	});

	return realEstateObjectsSorted.length > 0 && realEstateObjectsSorted[0] ? realEstateObjectsSorted[0] : null;
};

export default Project;